import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import infoList from "../../mixins/infoList";
import { taskList } from "@/api/task";
import { syncCpConfig } from "@/api/data";
import TaskOptions from "../../components/serverList/taskOptions.vue";
export default {
  components: {
    TaskOptions: TaskOptions
  },
  name: "gameTaskConfig",
  mixins: [infoList],
  data: function data() {
    return {
      //分页
      listApi: taskList,
      searchInfo: {
        task_id: ""
      }
    };
  },
  created: function created() {
    this.queryEvent();
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getTableData();
            case 2:
              if (!_this.tableData || _this.tableData && _this.tableData.length === 0) {
                _this.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openConfig: function openConfig() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return syncCpConfig({
                type: "c_task"
              });
            case 2:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.$message({
                  message: "同步cp配置成功",
                  type: "success"
                });
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "道具配置",
        dangerouslyUseHTMLString: true,
        message: "<div>(1)显示任务配置版本和列表，包含任务Id，任务名称，任务类型，任务进度</div>" + "<div>(2)任务类型定义包含：1主线任务，2支线任务，3日常任务。。。（根据游戏类型，可能有其他任务类型）。</div>" + "<div>(3)调用研发接口，更新任务配置，研发接口可返回json配置文件，包含配置版本，任务配置列表</div>",
        duration: 0
      });
    }
  }
};